import { RichText } from "./RichText";

export function MessageBody({ content, markdown }: { content: string; markdown: boolean }) {
	if (!markdown) return <div className="message-body">{content}</div>;

	return <RichText content={content} className="message-body" />;
}
